export function VoiceGatewayDownBanner({ detail }: { detail: string }) {
  return (
    <div role="alert" style={{
      padding: 16, marginBottom: 16,
      background: 'var(--vp-danger-soft, #FEE)',
      border: '1px solid var(--vp-danger, #b00020)',
      borderRadius: 'var(--vp-r-md, 8px)',
    }}>
      <strong>Voice-gateway non raggiungibile</strong>
      <p style={{ margin: '4px 0 0' }}>{detail}</p>
    </div>
  );
}
